<template>
  <section class="gardenManagementPage">
    <!-- <g-breadcrumb bread="视频列表" /> -->
    <!-- <el-button type="success" @click="addType" class="turnBule">添加分类</el-button> -->
    <SearchForm class="dis-flex flex-x-between flex-y-center">
      <el-form ref="ref_searchForm" :inline="true" :model="searchForm" label-width="80px">
        <el-form-item>
          <el-input v-model.trim="searchForm.itemName" placeholder="请输入物品名称" />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="searchForm.person" placeholder="请输入物品负责人" />
        </el-form-item>
         <!-- <el-form-item>
          <el-select
            v-model="searchForm.regStuats"
            placeholder="请选择来访状态"
            clearable
            @clear="queryXzRegisterPage"
          >
            <el-option
              v-for="(item, index) in regStuats"
              :key="index"
              :label="item.catName"
              :value="item.catName"
            />
          </el-select>
        </el-form-item>  -->
        <el-form-item>
          <!-- <el-button @click="cancelData">重置</el-button> -->
          <el-button type="primary" @click="queryXzCheckPage">搜 索</el-button>
        </el-form-item>
      </el-form>
      <el-button type="success" @click="addType" class="turnBule">添加物品</el-button>
    </SearchForm>
    <TableContainer title="">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        border
        :header-cell-style="tabHeader"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="id" label="序号" min-width="30" />
        <el-table-column prop="qcurl" label="物品码" min-width="80">
          <template slot-scope="scope">
            <img :src="scope.row.qcurl" width="80" height="80" />
          </template>
        </el-table-column>
        <el-table-column prop="organizationName" label="部门" min-width="60" />
        <el-table-column prop="person" label="负责人" min-width="60" />
        <el-table-column prop="company" label="单位" min-width="60" />
        <el-table-column prop="brand" label="品牌" min-width="60" />
        <el-table-column prop="itemName" label="物品" min-width="60" />
        <el-table-column prop="buyTime" label="物品详情" min-width="100">
          <template slot-scope="scope">
            <div class="t-l">
              <p>{{ scope.row.unit }}</p>
              <p>数量:{{ scope.row.num || "--" }}</p>
              <p v-show="scope.row.price!==''">购买价格:{{ scope.row.price || "--" }}元</p>
              <p v-show="scope.row.buyTime!==null">购买时间:{{ scope.row.buyTime || "--" }}</p>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="address" label="物品存放地址" min-width="60" />
        <el-table-column prop="remark" label="备注" min-width="100" />
        <el-table-column prop="stautsName" label="使用状态" min-width="60" />
        <el-table-column width="150" label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="textOrange" @click="editorFormClick(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" class="textOrange" @click="delXzCheck(scope.row)"
              >删除</el-button
            >
            <el-button type="text" class="textOrange" @click="scrap(scope.row)" v-show='scope.row.stauts==0'>报废</el-button>
            <el-button type="text" style="color:red" @ v-show='scope.row.stauts==1'>已报废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <GPagination
        v-show="total > 0"
        ref="ref_GPagination"
        :total="total"
        :page.sync="searchForm.page"
        :size.sync="searchForm.size"
        @pagination="queryXzCheckPage"
      />
    </TableContainer>

    <!-- 新增/编辑分类s -->
    <GDialog
      :dialog.sync="catDialog"
      @btnSure="catSubmitThemeForm()"
      @btnClose="resetThemeForm()"
      width="50%"
      :showCloseBtn="false"
      :showFooter="true"
    >
      <el-form ref="ref_themeForm" label-width="100px" @submit.native.prevent>
        <div class="dis-flex flex-x-start flex-y-start">
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="物品" label-width="40px" class="t-c">
              <el-input
                v-model="pxParmas.itemName"
                maxlength="35"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
            <p class="m-top15 col-6">*</p>
            <el-input
                v-model="pxParmas.num"
                maxlength="35"
                placeholder="数量"
                style="width:60px"
              />
               <p class="m-top15 col-6">*</p>
              <el-input
                v-model="pxParmas.company"
                maxlength="35"
                placeholder="单位"
                style="width:60px"
              />
          </div>
          <div class="dis-flex flex-x-start flex-y-start">
            <!-- <p class="m-top15 col-red"></p> -->
            <el-form-item label="品牌" label-width="60px" class="t-c">
              <el-input
                v-model="pxParmas.brand"
                maxlength="35"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
          </div>

  
        </div>
        <div class="dis-flex flex-x-between flex-y-start">
          <div class="dis-flex flex-x-start flex-y-start">
            <el-form-item label="规格" label-width="40px" class="t-c">
              <el-input
                v-model="pxParmas.unit"
                maxlength="35"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
          </div>
          <div class="dis-flex flex-x-start flex-y-start">
            <el-form-item label="价格" label-width="60px" class="t-c">
              <el-input
                v-model="pxParmas.price"
                maxlength="35"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
            
          </div>
          <div class="dis-flex flex-x-start flex-y-start">
            <el-form-item label="购买时间" label-width="80px" class="t-c">
              <el-date-picker
                v-model.trim="pxParmas.buyTime"
                type="date"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                @change="selectTime"
              >
              </el-date-picker>
            </el-form-item>
          </div>
  
  
       

        </div>
        <div class="dis-flex flex-x-between flex-y-start">
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="物品部门" label-width="80px">
              <el-select
                v-model="pxParmas.organizationId"
                placeholder="请选择"
                @change="(val) => partChangeType(val)"
                filterable
                allow-create
                default-first-option
              >
                <el-option
                  v-for="(item, index) in partList"
                  :key="index"
                  :label="item.organizationName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>
          <div
            class="dis-flex flex-x-start flex-y-start"
            style="margin-left: 20px"
           
          >
          <div class="dis-flex flex-x-start flex-y-start">
            <!-- <p class="m-top15 col-red">*</p> -->
            <el-form-item label="负责人" label-width="60px" class="t-c">
              <el-input
                v-model="pxParmas.person"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
          </div>
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="编号" label-width="60px" class="t-c">
              <el-input
                v-model="pxParmas.no"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
          </div>
          </div>
        </div>
       

      

        <div class="dis-flex flex-x-start flex-y-start">
          <p class="m-top15 col-red">*</p>
          <el-form-item label="存放地址" label-width="80px">
            <textarea
              id="content"
              name="content"
              rows="3"
              cols="80"
              style="width: 100%; border: 1px solid #58e3e8"
              v-model="pxParmas.address"
            ></textarea>
          </el-form-item>
        </div>
        <div class="dis-flex flex-x-start flex-y-start">
          <el-form-item label="物品备注" label-width="90px">
            <textarea
              id="content"
              name="content"
              rows="3"
              cols="80"
              style="width: 100%; border: 1px solid #58e3e8"
              v-model="pxParmas.remark"
            ></textarea>
          </el-form-item>
        </div>
      </el-form>
    </GDialog>
    <!--  新增/编辑分类e -->
  </section>
</template>

<script>
import {
  queryXzCheckPage,
  delPxCat,
  selectDcDept,
  selectMinDcDept,
  addXzCheck,
  updateXzCheck,
  delXzCheck,
} from "@api/bx/api_contentManagement";
import uploadPics from "@/components/Upload/uploadPics.vue";
import uploadList from "@/components/Upload/uploadList.vue";
export default {
  components: { uploadPics, uploadList },
  data() {
    return {
      tiny: {
        value: undefined,
      },
      themeDialog: {
        title: "信息框",
        visible: false,
      },
      catDialog: {
        title: "操作",
        visible: false,
      },
      searchForm: {
        page: 1,
        size: 10,
        itemName:'',
        person:''
      },
      total: 0,
      tableData: [],
      editor: 0,
      typeList: [],
      partList: [],
      checkedCities: [],
      noticeTitle: "",
      partName: "",
      roleId: "",
      catInfo: "",
      content: "",
      pxParmas: {
        organizationId: "",
        person: "",
        no: "",
        itemName: "",
        num: 1,
        brand: "",
        price: "",
        unit: "",
        buyTime: "",
        company: "",
        address: "",
        remark:'',
        stauts:0
      },
      id: "",
    };
  },
  created() {
    this.queryXzCheckPage();
    // this.selectDcDept();
    this.selectMinDcDept();
  },
  methods: {
    tabHeader() {
      return "backgroundColor:rgba(88, 227, 232, 0.12);color:#000;font-weight:bold;font-size:15px;text-align: center;";
    },
    partChangeType() {
      // console.log(this.pxParmas.organizationId);
    },
 //时间筛选
  selectTime(val) {
      if (val == null) {
        this.pxParmas.buyTime = "";
      } else {
        this.pxParmas.buyTime = val;
      }
    },
    handleCheckedCitiesChange(val) {
      console.log(val);
    },
    resetThemeForm() {
      this.editor = 0;
      this.pxParmas.organizationId=""
        this.pxParmas.person=""
        this.pxParmas.no=""
        this.pxParmas.itemName=""
        this.pxParmas.num= 1
        this.pxParmas.brand=""
        this.pxParmas.price=""
        this.pxParmas.unit=""
        this.pxParmas.buyTime=""
        this.pxParmas.company=""
        this.pxParmas.address=""
        this.pxParmas.remark=""
        this.pxParmas.stauts=0
        this.id =""
      this.catDialog.visible = false;
    },
    // 部门列表
    selectDcDept() {
      selectDcDept({}).then((res) => {
        this.typeList = res;
      });
    },
    //多部门列表
    selectMinDcDept() {
      selectMinDcDept({}).then((res) => {
        this.partList = res;
      });
    },
    // 初始化列表
    queryXzCheckPage() {
      queryXzCheckPage(this.searchForm).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    //分类新增,编辑
    catSubmitThemeForm() {
      if (this.pxParmas.organizationId == "") {
        this.$message.warning("请选择物品部门");
        return;
      }
      if (this.pxParmas.no == "") {
        this.$message.warning("请输入物品编号");
        return;
      }
      if (this.pxParmas.itemName == "") {
          this.$message.warning("请输入物品名称");
          return;
      }
      if (this.pxParmas.num == "") {
          this.$message.warning("请输入物品数量");
          return;
      }
        if (this.pxParmas.address == "") {
          this.$message.warning("请输入存放地址");
          return;
        }

      if (this.editor == "0") {
        // return
        //首次提交
        addXzCheck(this.pxParmas).then((res) => {
          this.$message.success("新增分类成功");
          this.resetThemeForm();
          this.queryXzCheckPage();

        });
      } else {
        //编辑提交
        updateXzCheck({
        organizationId:this.pxParmas.organizationId,
        person:this.pxParmas.person,
        no:this.pxParmas.no,
        itemName:this.pxParmas.itemName,
        num:this.pxParmas.num,
        brand:this.pxParmas.brand,
        price:this.pxParmas.price,
        unit:this.pxParmas.unit,
        buyTime:this.pxParmas.buyTime,
        company:this.pxParmas.company,
        address:this.pxParmas.address,
        remark:this.pxParmas.remark,
        stauts:this.pxParmas.stauts,
        id:this.id,
        }).then((res) => {
          this.$message.success("编辑成功");
          this.resetThemeForm();
          this.queryXzCheckPage();
        });
      }
    },
    //添加
    addType() {
      this.catDialog.visible = true;
    },
    //编辑
    editorFormClick(row) {
      console.log(row);
      this.editor = 1;
        this.pxParmas.organizationId= row.organizationId
        this.pxParmas.person= row.person
        this.pxParmas.no= row.no
        this.pxParmas.itemName= row.itemName
        this.pxParmas.num= row.num
        this.pxParmas.brand= row.brand
        this.pxParmas.price= row.price
        this.pxParmas.unit= row.unit
        this.pxParmas.buyTime= row.buyTime
        this.pxParmas.company= row.company
        this.pxParmas.address= row.address
        this.pxParmas.remark= row.remark
        this.id = row.id;
      this.catDialog.visible = true;
    },
    //删除
    delXzCheck(row) {
      this.$confirm("永久删除【" + row.person+row.itemName + "】这条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delXzCheck({ id: row.id }).then((res) => {
          this.queryXzCheckPage();
        });
      });
    },
    scrap(row) {
      this.$confirm("永久报废【" + row.person+row.itemName + "】这条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateXzCheck({ id: row.id,stauts: 1 }).then((res) => {
          this.queryXzCheckPage();
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* .tree /deep/ .el-tree-node__content{
		padding-left: 40px
	} */
.turnBule {
  color: #fff;
  background-color: #58e3e8;
  border-color: rgba(56, 185, 190, 0.12);
  margin-left: 15px;
}

.turnBule:hover,
.turnBule:focus {
  background: rgba(56, 185, 190, 0.5);
  border-color: rgba(56, 185, 190, 0.5);
  color: #fff;
}

.el-button--text.reviewed {
  color: #38b9be;
}

.reviewed {
  color: #38b9be;
}

.el-tree-node__content {
  z-index: 999;
  padding-left: 40px;
}

.directory-in {
  width: 32%;
  line-height: 60px;
  background: #4095e5;
}
</style>
